import * as React from "react";
import { CompoundTag, Icon } from "@blueprintjs/core";
import { css } from "@emotion/core";

interface ProcessProgressProps {
  current: number;
  size: "small" | "large";
}

export default function ProcessProgress(props: ProcessProgressProps) {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin: 1rem 0;
        gap: 2rem;
      `}
    >
      <div>
        <CompoundTag
          intent={props.current === 1 ? "primary" : "success"}
          leftContent={
            <div
              css={css`
                width: 2rem;
                height: 2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: ${props.size === "small" ? "1.1rem" : "1.5rem"};
                line-height: ${props.size === "small" ? "1.1rem" : "1.5rem"};
                font-weight: 700;
              `}
            >
              {props.current === 1 ? "1" : <Icon icon="tick" />}
            </div>
          }
          round
          size="large"
        >
          <div
            css={css`
              height: 2rem;
              font-size: ${props.size === "small" ? "1.1rem" : "1.5rem"};
              line-height: ${props.size === "small" ? "1.5rem" : "1.1rem"};
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0 1rem;
            `}
          >
            Select Products
          </div>
        </CompoundTag>
      </div>
      <div
        css={css`
          display: flex;
          align-items: center;
          justify-content: center;
        `}
      >
        <Icon icon="chevron-right" size={32} />
      </div>
      <div>
        <CompoundTag
          intent={props.current <= 2 ? "primary" : "success"}
          minimal={props.current === 1}
          leftContent={
            <div
              css={css`
                width: 2rem;
                height: 2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: ${props.size === "small" ? "1.1rem" : "1.5rem"};
                line-height: ${props.size === "small" ? "1.1rem" : "1.5rem"};
                font-weight: 700;
              `}
            >
              {props.current <= 2 ? "2" : <Icon icon="tick" />}
            </div>
          }
          round
          size="large"
        >
          <div
            css={css`
              height: 2rem;
              font-size: ${props.size === "small" ? "1.1rem" : "1.5rem"};
              line-height: ${props.size === "small" ? "1.1rem" : "1.5rem"};
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0 1rem;
            `}
          >
            Select Input Files
          </div>
        </CompoundTag>
      </div>
      <div
        css={css`
          display: flex;
          align-items: center;
          justify-content: center;
        `}
      >
        <Icon
          icon="chevron-right"
          size={32}
          color={props.current < 3 ? "var(--neutral-4)" : "var(--neutral-3)"}
        />
      </div>
      <CompoundTag
        intent="primary"
        minimal={props.current < 3}
        leftContent={
          <div
            css={css`
              width: 2rem;
              height: 2rem;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: ${props.size === "small" ? "1.1rem" : "1.5rem"};
              line-height: ${props.size === "small" ? "1.1rem" : "1.5rem"};
              font-weight: 700;
            `}
          >
            3
          </div>
        }
        round
        size="large"
      >
        <div
          css={css`
            height: 2rem;
            font-size: ${props.size === "small" ? "1.1rem" : "1.5rem"};
            line-height: ${props.size === "small" ? "1.1rem" : "1.5rem"};
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 1rem;
          `}
        >
          Confirm and Upload
        </div>
      </CompoundTag>
    </div>
  );
}
